import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// Kendo controls
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
// Class + Components + Function
import { TapStripAmountContent } from "./TapStripAmountContent";
import TapStripSubjectContent from "./TapStripSubjectContent";
import { Timer } from "../../../Components/Common/Timer";
import MessageBox, { Pattern, Title } from '../../Common/MessageBox';
import { MessageBoxKey, MessageBoxModel } from '../../../Models/CommonModel/MessageBoxModel';
import { AllActionId } from '../../../Models/StateModel/ActionStateModel';
//Resource + CSS
import Screen from "../../../Resources/Screen.json";
import "../../../Assets/Components/GridContent.css";

const timer = new Timer(10000);
function GridContent(props) {
    const actionState = useSelector(state => state.ActionState.actionState);

    const [currentTap, setCurrentTap] = useState(0);

    // MessageBox
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [messageDialog, setMessageDialog] = useState(null);

    useEffect(() => {
        // Dispose timer if component unmount
        return function cleanup() {
            timer.dispose();
        };
    }, [])

    const handleSelectTap = (event) => {
        setCurrentTap(event.selected);
    }

    //Show MessageBox if not select item transfer
    const onShowErrMessageBox = () => {
        let dialog = new MessageBoxModel({
            Sid: MessageBoxKey.SubmitFinancialStatements,
            Title: Title.DefaultTitle,
            Pattern: Pattern.Ok,
            Message: Screen.MessageBox.NotSelectItemTransfer
        });
        setMessageDialog(dialog);
        setShowMessageBox(true);
    }

    const onSubmitMessageBox = (sid, value) => {
        // reset dialog & close
        setMessageDialog(null);
        setShowMessageBox(false);
    }

    return (
        <React.Fragment>
            {messageDialog && showMessageBox && <MessageBox sid={messageDialog.Sid} title={messageDialog.Title} pattern={messageDialog.Pattern} message={messageDialog.Message} submit={onSubmitMessageBox}></MessageBox>}
            <div className="pnxBlockTreeView" style={{ marginTop: "10px" }}>
                <div className="row">
                    <div className="col-left"></div>
                    <div className="col-center" style={{ paddingLeft: "0px" }}>
                        <TabStrip style={{ width: "100%" }} className={actionState.IsDisable(AllActionId.TabTransfer) ? "inactive-tab" : "active-tab"} selected={currentTap} onSelect={handleSelectTap} animation={true} keepTabsMounted={true}>
                            <TabStripTab title={Screen.MainPage.TitleAmount} style={{ minHeight: "700px" }} disabled={actionState.IsDisable(AllActionId.TabTransfer) && currentTap === 1} >
                                <TapStripAmountContent
                                    onShowErrMessageBox={onShowErrMessageBox}>
                                </TapStripAmountContent>
                            </TabStripTab>
                            <TabStripTab title={Screen.MainPage.TitleAccount} style={{ minHeight: "700px" }} disabled={actionState.IsDisable(AllActionId.TabTransfer) && currentTap === 0}   >
                                <TapStripSubjectContent
                                    onShowErrMessageBox={onShowErrMessageBox}>
                                </TapStripSubjectContent>
                            </TabStripTab>
                        </TabStrip>
                    </div>
                    <div className="col-right"></div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default GridContent;